export default __webpack_public_path__ + "static/media/nhls.fe1f2f10.png";